import React from 'react';
import { Button } from '@mui/material';

import { ResponsiveDialog, useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import useUsersLoginLogsColumns from './UsersLoginLogsColumns';

interface UsersLoginLogsListDialogProps {
	open: boolean;
	onClose: VoidFunction;
	model: any;
	filters?: MiddlewhereFilter[];
}

function UsersLoginLogsListDialog(props: UsersLoginLogsListDialogProps) {
	const { t, settings } = useSettings('sys_logs');

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(state => !state);

	const columns = useUsersLoginLogsColumns({ settings, t, updateRefresh });

	return (
		<ResponsiveDialog
			open={props.open}
			onClose={props.onClose}
			classes={{ content: 'flex flex-col p-0' }}
			maxWidth="sm"
			disablePadding
			dividers
			title={t('USER_LOGIN_LOGS')}
			content={
				<>
					<ViewTable
						className="border-none"
						module="sys_logs"
						defaultFilters={props.model.dwid_defaultfilters}
						filters={props.filters}
						refresh={refresh}
						updateRefresh={updateRefresh}
						columns={columns}
						showFilters={false}
					/>
				</>
			}
			actions={<Button onClick={props.onClose}>{t('DIALOG_ACTION_CLOSE')}</Button>}
		/>
	);
}

export default React.memo(UsersLoginLogsListDialog);
